<template>
  <v-card id="entityDevices">
    <v-card-text>
      <h2><v-icon>phone_android</v-icon>Devices</h2>
      <span v-if="!entity.devices || entity.devices.length == 0"
        >No smartphone devices registered</span
      >
      <v-data-table
        :headers="computedHeaders"
        :items="entity.devices"
        v-if="entity.devices && entity.devices.length > 0"
        hide-actions
        class="elevation-1"
      >
        <template v-slot:items="props">
          <tr>
            <td>{{ props.item.id }}</td>
            <td>{{ props.item.typeid == 1 ? "Apple" : "Android" }}</td>
            <td>{{ props.item.token }}</td>
            <td v-if="$keycloak.hasRealmRole('root')">
              <v-btn @click="pingDevice(props.item)">Ping</v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import UPDATE_ENTITY_DEVICE_MESSAGE from "@/graphql/directory/UpdateEntityDeviceMessage";
export default {
  name: "Device",
  props: ["entity"],
  computed: {
    computedHeaders() {
      const adminColumn = this.$keycloak.hasRealmRole("root")
        ? {
            text: "Admin",
            sortable: false
          }
        : null;
      return [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "Type",
          value: "typeid"
        },
        {
          text: "Token",
          sortable: false
        },
        adminColumn
      ];
    }
  },
  methods: {
    async pingDevice(device) {
      await this.$apollo.mutate({
        mutation: UPDATE_ENTITY_DEVICE_MESSAGE,
        variables: {
          id: Number(this.$route.params.id),
          deviceid: device.id,
          body: "pinging"
        },
        result({ data }) {
          console.log(data);
        }
      });
    }
  }
};
</script>
